var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelieved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.083 46C40.1287 46 49.083 37.0457 49.083 26C49.083 14.9543 40.1287 6 29.083 6C18.0373 6 9.08301 14.9543 9.08301 26C9.08301 37.0457 18.0373 46 29.083 46Z",
    fill: "#C2DCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46.9C33.5428 46.9 42.9 37.5428 42.9 26C42.9 14.4572 33.5428 5.1 22 5.1C10.4572 5.1 1.1 14.4572 1.1 26C1.1 37.5428 10.4572 46.9 22 46.9Z",
    fill: "white",
    stroke: "#0045A4",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6671 23.3337C12.6671 24.041 12.9481 24.7193 13.4482 25.2194C13.9483 25.7195 14.6265 26.0004 15.3338 26.0004C16.041 26.0004 16.7193 25.7195 17.2194 25.2194C17.7195 24.7193 18.0004 24.041 18.0004 23.3337M26.0004 23.3337C26.0004 24.041 26.2814 24.7193 26.7815 25.2194C27.2816 25.7195 27.9599 26.0004 28.6671 26.0004C29.3744 26.0004 30.0526 25.7195 30.5527 25.2194C31.0528 24.7193 31.3338 24.041 31.3338 23.3337",
    stroke: "#0045A4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 32.1802C26.1655 33.8401 24.0913 34.6971 21.9853 34.6654C19.8794 34.6337 17.8155 33.7144 16.0004 31.9996",
    stroke: "#0045A4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 20.0002C31.4031 19.0618 30.4996 17.6474 27.9996 18.0807",
    stroke: "#0045A4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 20.0002C13.263 19.0618 14.1665 17.6474 16.6665 18.0807",
    stroke: "#0045A4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelieved);
export default __webpack_public_path__ + "static/media/relieved.8e2b663f.svg";
export { ForwardRef as ReactComponent };